<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="headerText" canGoBack small></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy" rounded :marginTop="55">
            <div class="px-5">
                <div class="list-faq-group">
                    <template v-for="(item, idx) of items" :key="`faq-g-${idx}`">
                        <div class="first:pt-0 py-4 border-b">
                            <div class="flex items-start" @click="togglePanel(idx, item)">
                                <div class="flex-auto mx-3 text-gray-700" v-html="item.Questions"></div>
                                <div class="flex-none pt-2">
                                    <img
                                        class="w-4 h-4 transform duration-100"
                                        :class="[states[idx] ? '-rotate-90' : 'rotate-90']"
                                        src="@/assets/icon/arrow/arrow-chevron-right.svg"
                                        alt
                                    />
                                </div>
                            </div>
                            <div
                                class="rounded-lg bg-light-blue-1 text-blue-1 p-10px mt-4 break-words"
                                v-if="states[idx]"
                                v-html="newLineToBr(item.Answer)">
                            </div>
                            <!-- <transition
                                enter-active-class="transition transition-height ease-out duration-500"
                                enter-from-class="transition-height h-0"
                                enter-to-class="transition-height h-full"
                                leave-active-class="transition transition-height ease-in duration-200"
                                leave-from-class="transition-height h-full"
                                leave-to-class="transition-height h-0"
                            >

                            </transition>-->
                        </div>
                    </template>
                </div>
            </div>
        </PageContent>
        <ButtonFBMessenger :text="lbl.faq.fb"></ButtonFBMessenger>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>
</template>

<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import ButtonFBMessenger from "../component/ButtonFBMessenger.vue"
import ConfigManager from "@/config/ConfigManager.js";
// mixin
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"
// service
import BzbsService from '@/core/Custom/service/CustomService';
// helper
import Utility from "@/helper/Utility";

export default {
    name: "FAQDetailPage",
    mixins: [LocaleMixin, ErrorApiMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        ButtonFBMessenger,
    },
    data: function () {
        return {
            hasPoweredBy: false,
            faq_config_file: 'FAQ.json',
            headerText: '',
            items: [
            ],
            states: [],
            trackingScreenName: 'faq_question_list',
        }
    },
    created: function () {
        this.initFaq()
        this.states = this.items.map(() => {
            return false
        })
        this.tracking.screenName(this.trackingScreenName);
    },
    methods: {
        togglePanel: function (idx, selected) {
            this.states[idx] = !this.states[idx]
            this.tracking.event('question_list', 'click_question_list', selected.q, null);
        },
        initFaq: function(){
            let key = this.$route.params.key;
            const url = ConfigManager.getBlobUrl()  + '/webconfig/jcb/' + this.localeCode + '/' + this.faq_config_file;
            BzbsService.apiGetBlobContent(url).subscribe(
                {
                    next: (data) => {
                        for (var item of data) {
                            if(item.id == key){
                                const lblHeader = item.groupName.split(":");
                                this.headerText = lblHeader[1];
                                this.items = item.info;
                            }
                        }
                    },
                    error: (err) => {
                        this.errorApi(err)
                    }
                }
            )
        },
        newLineToBr: function(str){
            return Utility.newLineToBr(str)
        }
    }
}
</script>
